export interface IHTTPResponseData {
    [index: string]: {} | undefined;
    tags?: string[];
    status?: string;
    errorcode?: string;
}

/**
 * HTTP Post request
 *
 * @param url
 * @param parameters
 */
export async function httpPostRequest (url: string, parameters?: {[index: string]: {} | undefined}): Promise<IHTTPResponseData | undefined>
{
    const init: RequestInit = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
        },
    };

    if (parameters)
    {
        init.body = JSON.stringify(parameters);
    }

    let response: Response | undefined = undefined;

    try
    {
        response = await fetch(url, init);
    }
    catch (error)
    {
        console.error(error);

        return;
    }

    const STATUS_OK = 200;

    if (response.status !== STATUS_OK)
    {
        throw new Error(`${response.status.toString()}: Fetch failed (${url})`);
    }

    return await response.json() as IHTTPResponseData;
}
